export class AmaFooterModel {
  constructor() {}

  public content = {
    mission:
      'The AMA promotes the art and science of medicine and the betterment of public health.',
    categories: [
      {
        title: 'FREIDA RESOURCES',
        links: [
          {
            title: 'Explore Specialties',
            ariaLabel: 'Explore Specialties',
            url: '/specialty',
          },
          {
            title: 'Institution Directory',
            ariaLabel: 'Institution Directory',
            url: '/institution',
          },
          {
            title: 'Contact Freida',
            ariaLabel: 'Contact Freida',
            url: '/contact',
          },
          {
            title: 'Member Benefits',
            ariaLabel: 'Member Benefits',
            url: '/memberbenefits',
          },
          {
            title: 'FAQ',
            ariaLabel: 'FAQ',
            url: '/faq',
          }
        ],
      },
      {
        title: 'OUR WORK',
        links: [
          {
            title: 'Fixing prior authorization',
            ariaLabel: 'Fixing prior authorization',
            url: 'https://www.ama-assn.org/amaone/why-we-fight-fixing-prior-authorization',
          },
          {
            title: 'Reforming Medicare payment',
            ariaLabel: 'Reforming Medicare payment',
            url: 'https://www.ama-assn.org/amaone/why-we-fight-reforming-medicare-payment',
          },
          {
            title: 'Reducing physician burnout',
            ariaLabel: 'Reducing physician burnout',
            url: 'https://www.ama-assn.org/amaone/why-we-fight-reducing-physician-burnout',
          },
          {
            title: 'Making technology work for physicians',
            ariaLabel: 'Making technology work for physicians',
            url: 'https://www.ama-assn.org/amaone/why-we-fight-making-technology-work-physicians',
          },
          {
            title: 'State advocacy',
            ariaLabel: 'State advocacy',
            url: 'https://www.ama-assn.org/health-care-advocacy/state-advocacy',
          },
          {
            title: 'Explore all topics',
            ariaLabel: 'Explore all topics',
            url: 'https://www.ama-assn.org/about/topic-catalog',
          },
        ],
      },
      {
        title: 'CAREER RESOURCES',
        links: [
          {
            title: 'CME from AMA Ed Hub™',
            ariaLabel: 'CME from AMA Ed Hub™',
            target: '_blank',
            rel: 'noopener',
            url: 'https://edhub.ama-assn.org/pages/find-cme-keep-current',
          },
          {
            title: 'FREIDA™',
            ariaLabel: 'FREIDA',
            target: '_blank',
            rel: 'noopener',
            url: 'https://freida.ama-assn.org/',
          },
          {
            title: 'AMA UME Curricular Enrichment Program',
            ariaLabel: 'AMA UME Curricular Enrichment Program',
            target: '_blank',
            rel: 'noopener',
            url: 'https://edhub.ama-assn.org/ama-ume-program',
          },
          {
            title: 'AMA GME Competency Education Program',
            ariaLabel: 'AMA GME Competency Education Program',
            target: '_blank',
            rel: 'noopener',
            url: 'https://signin.curriculum.ama-assn.org/',
          },
          {
            title: 'AMA Physician Education Program',
            ariaLabel: 'AMA Physician Education Program',
            target: '_blank',
            rel: 'noopener',
            url: 'https://edhub.ama-assn.org/physician-education-program',
          },
          {
            title: 'JAMA Career Center',
            ariaLabel: 'JAMA Career Center',
            target: '_blank',
            rel: 'noopener',
            url: 'https://careers.jamanetwork.com/',
          },
          {
            title: 'AMA Physician Profile',
            ariaLabel: 'AMA Physician Profile',
            target: '_blank',
            rel: 'noopener',
            url: 'https://commerce.ama-assn.org/amaprofiles/',
          },
        ],
      },
      {
        title: 'ABOUT',
        links: [
          {
            title: 'Membership',
            ariaLabel: 'AMA Physician Profile',
            url: 'https://www.ama-assn.org/membership/member-eligibility-dues/ama-membership-dues',
          },
          {
            title: 'Press Center',
            ariaLabel: 'Press Center',
            url: 'https://www.ama-assn.org/press-center',
          },
          {
            title: 'Policy',
            ariaLabel: 'Policy',
            target: '_blank',
            rel: 'noopener',
            url: 'https://policysearch.ama-assn.org/policyfinder',
          },
          {
            title: 'Code of Medical Ethics',
            ariaLabel: 'Code of Medical Ethics',
            target: '_blank',
            rel: 'noopener',
            url: 'https://code-medical-ethics.ama-assn.org/',
          },
          {
            title: 'Newsletters',
            ariaLabel: 'Newsletters',
            url: 'https://www.ama-assn.org/membership/benefits-discounts/ama-morning-rounds-your-daily-dose-health-care-news',
          },
          {
            title: 'Events',
            ariaLabel: 'Events',
            url: 'https://www.ama-assn.org/membership/events',
          },
          {
            title: 'Careers',
            ariaLabel: 'Careers',
            url: 'https://www.ama-assn.org/about/ama-career-opportunities',
          },
          {
            title: 'Contact Us',
            ariaLabel: 'Contact Us',
            url: 'https://www.ama-assn.org/form/contact-us',
          },
        ],
      },
      {
        title: 'AFFILIATES & SUBSIDIARIES',
        links: [
          {
            title: 'AMPAC',
            ariaLabel: 'AMPAC',
            target: '_blank',
            rel: 'noopener',
            url: 'https://ampaconline.org/',
          },
          {
            title: 'AMA Foundation',
            ariaLabel: 'AMA Foundation',
            target: '_blank',
            rel: 'noopener',
            url: 'https://amafoundation.org/',
          },
          {
            title: 'AMA Alliance',
            ariaLabel: 'AMA Alliance',
            target: '_blank',
            rel: 'noopener noreferrer',
            url: 'https://amaalliance.org/',
          },
          {
            title: 'AMA Insurance',
            ariaLabel: 'AMA Insurance',
            target: '_blank',
            rel: 'noopener noreferrer',
            url: 'https://amainsure.com/',
          },
          {
            title: 'Health2047',
            ariaLabel: 'Health2047',
            target: '_blank',
            rel: 'noopener noreferrer',
            url: 'https://health2047.com/',
          },
        ],
      },
    ],

    social: [
      {
        title: 'LinkedIn',
        target: '_blank',
        rel: 'noopener noreferrer',
        url: 'https://www.linkedin.com/company/american-medical-association',
        icon: 'ph-linkedin-logo',
      },
      {
        title: 'X',
        ariaLabel: 'X',
        target: '_blank',
        rel: 'noopener noreferrer',
        url: 'https://x.com/AmerMedicalAssn',
        icon: 'ph-twitter-logo',
      },
      {
        title: 'Facebook',
        ariaLabel: 'Facebook',
        target: '_blank',
        rel: 'noopener noreferrer',
        url: 'https://www.facebook.com/AmericanMedicalAssociation',
        icon: 'ph-facebook-logo',
      },
      {
        title: 'Instagram',
        ariaLabel: 'Instagram',
        target: '_blank',
        rel: 'noopener noreferrer',
        url: 'https://www.instagram.com/amermedicalassn/',
        icon: 'ph-instagram-logo',
      },
      {
        title: 'Youtube',
        ariaLabel: 'Youtube',
        target: '_blank',
        rel: 'noopener noreferrer',
        url: 'https://www.youtube.com/user/AmerMedicalAssn',
        icon: 'ph-youtube-logo',
      },
      {
        title: 'Bluesky',
        ariaLabel: 'Bluesky',
        target: '_blank',
        rel: 'noopener noreferrer',
        url: 'https://bsky.app/profile/ama-assn.org',
        icon: 'bluesky',
      },
    ],
    utility: [
      {
        title: 'View the AMA Code of Conduct and Anti-harassment policy. ',
        label: 'Code of Conduct',
        ariaLabel: 'Code of Conduct',
        url: 'https://www.ama-assn.org/about/code-conduct',
      },
      {
        title:
          'Read the Terms of Use for accessing and using any AMA website or online property. If you do not agree to the Terms, please exit the AMA website.',
        label: 'Terms of Use',
        ariaLabel: 'Terms of Use',
        url: 'https://www.ama-assn.org/about/terms-use',
      },
      {
        title:
          'The American Medical Association (AMA) respects your privacy and is committed to protecting it at all times. ',
        label: 'Privacy Policy',
        ariaLabel: 'Privacy Policy',
        url: 'https://www.ama-assn.org/about/privacy-policy',
      },
      {
        title:
          "Read about the American Medical Association's commitment to providing a website that is accessible to all users, including those with disabilities.",
        label: 'Website Accessibility',
        ariaLabel: 'Website Accessibility',
        url: 'https://www.ama-assn.org/about/accessibility-statement',
      },
      {
        title: 'Share your screen with a live AMA support agent',
        label: 'Share Your Screen',
        ariaLabel: 'Share Your Screen',
        url: 'https://cdn.rcrsv.io/five9/americanmedicalassociation/index.html',
      },
      {
        title: 'View the AMA Code of Conduct and Anti-harassment policy.',
        label: 'Cookie Settings',
        ariaLabel: 'Cookie Settings',
        url: '',
      },
    ],
  };
}
